import { ReactNode, useEffect, useRef } from "react";
import { AuthContext } from "./AuthContext";
import { supabaseService } from "@/shared/services/supabase-auth-service";
import { useSelector } from "react-redux";
import { persistor, RootState } from "../redux/store";
import { useDispatch } from "react-redux";
import { setUser } from "../redux/slices/user";
import { trackUserLogout } from "@/lib/rum-actions";

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const dispatch = useDispatch();
  const { user, loading, error } = useSelector(
    (state: RootState) => state.user
  );
  // Track session start time for RUM tracking
  const sessionStartTime = useRef<number>(Date.now());

  const login = (userData: any) => {
    sessionStartTime.current = Date.now(); // Reset session start on login
    dispatch(setUser(userData));
  };

  const logout = async () => {
    // RUM-039: Track user logout
    if (user?.id) {
      const sessionDuration = Date.now() - sessionStartTime.current;
      trackUserLogout(user.id, sessionDuration, 'manual');
    }

    localStorage.clear();
    dispatch(setUser(null));
    await persistor.purge();
    supabaseService.signOut();
    // const loginPath = `/${ROUTES.Auth.Root}/${ROUTES.Auth.SignIn}`;
    // navigate(loginPath);
  };

  const userCheck = async () => {
    const userLocal = localStorage.getItem("user");
    const token = localStorage.getItem("accessToken");

    if (userLocal && token) {
      const userData = JSON.parse(userLocal);
      login(userData);
    }
  };

  useEffect(() => {
    userCheck();
  }, []);

  const value = {
    user,
    loading,
    error,
    login,
    logout,
    isAuthenticated: !!user,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
